import { ROUTES } from '../../../routes';

export const SubmenuFisca = (indexToColor?: string) => {
  return [
    {
      label: 'Introduction à la comptabilité financière',
      sumaryLabel: 'Comptabilité financière',
      link: ROUTES.FISCA.COMPTA_FINANCE,
      content: 'In progress...',
      color: indexToColor === '1' ? true : false,
    },
    {
      label: 'Comptabilité des obligations',
      sumaryLabel: 'Comptabilité des obligations',
      link: ROUTES.FISCA.COMPTA_OBLIG,
      content: 'In progress...',
      color: indexToColor === '2' ? true : false,
    },
    {
      label: 'Fiscalité des obligations',
      sumaryLabel: 'Fiscalité des obligations',
      link: ROUTES.FISCA.FISCALITE_OBLIG,
      content: 'In progress...',
      color: indexToColor === '3' ? true : false,
    },
    {
      label: 'Analyse des états financiers',
      sumaryLabel: 'Analyse des états financiers',
      link: ROUTES.FISCA.ANALYSE_ETAT,
      content: 'In progress...',
      color: indexToColor === '4' ? true : false,
    },
    {
      label: 'Gestion des risques financiers',
      sumaryLabel: 'Risques financiers',
      link: ROUTES.FISCA.RISQUE_FINANCE,
      content: 'In progress...',
      color: indexToColor === '5' ? true : false,
    },
    {
      label: 'Éthique et réglementation',
      sumaryLabel: 'Éthique & réglementation',
      link: ROUTES.FISCA.ETHIQUE_REGL,
      content: 'In progress...',
      color: indexToColor === '6' ? true : false,
    },
  ];
};
